module.exports = __webpack_public_path__ + "img/837000214_13.0a47f392.png";